import { getAccessTokenJwtHeader } from '@/assets/src/amplify/helpers';
import { getJson } from '@/assets/src/json_loader';
import { API_URL } from '@/assets/src/configs';

const listStripePlans = `${API_URL}/private/stripe/plans`;
const listStripeCoupons = `${API_URL}/private/stripe/coupons`;

export interface StripePlan {
  id: string;
  name: string;
}

export interface StripeCoupon {
  id: string;
  name: string;
  percent_off: number;
  amount_off: number;
  created: string;
  currency: string;
  deleted: boolean;
  duration: string;
  duration_in_months: number;
  max_redemptions: number;
  times_redeemed: number;
  redeem_by: string | null;
  valid: boolean;
}

export class StripeClient {
  public async listStripeCoupons(): Promise<StripeCoupon[]> {
    const headers = await getAccessTokenJwtHeader();
    const response: any = await getJson(listStripeCoupons, headers);

    return response.coupons;
  }

  public async listStripePlans(): Promise<StripePlan[]> {
    const headers = await getAccessTokenJwtHeader();
    const response: any = await getJson(listStripePlans, headers);

    return response.plans;
  }
}
